// Copyright (c) 2017 Deere & Company

import Product from '@deere/cps-it.warranty-model-factory/lib/product';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateProduct = (state, action) =>
    Product.update(state, {
        $set: action.data
    });

export default (state = getDefaultState().product, action) => {

    const actionTypes = {
        [actions.UPDATE_PRODUCT_REGISTRATION_PRODUCT]: updateProduct
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/product/product-registration/reducers/product-details.js